const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Arrow defs ────────────────────────────────────────────────────
function AD() {
  return (
    <defs>
      <marker id="mR"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
      <marker id="mB"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#2E75B6"/></marker>
      <marker id="mG"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#27ae60"/></marker>
      <marker id="mO"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#e07b00"/></marker>
      <marker id="mP"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#9b59b6"/></marker>
      <marker id="mGy" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
    </defs>
  );
}

// ── Shared spring path ────────────────────────────────────────────
function spr(x0, x1, y, n=8) {
  const cw=(x1-x0)/n; const pts=[[x0,y]];
  for(let i=0;i<n;i++){pts.push([x0+i*cw+cw*.25,y-13]);pts.push([x0+i*cw+cw*.75,y+13]);}
  pts.push([x1,y]);
  return pts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
}

// ─────────────────────────────────────────────────────────────────
// Diagram 1 — What modal analysis is: the big picture overview
// ─────────────────────────────────────────────────────────────────
function DiagOverview() {
  const W=900, H=320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Modal Analysis — The Big Picture</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* Three columns: Analytical / Experimental / Applications */}
        {[
          {
            x:10, w:268, color:'#2E75B6', bg:'#eaf3ff', title:'Analytical Modal Analysis',
            sub:'Start from the model',
            items:['Build [M], [K], [C] matrices','Solve eigenvalue problem','det([K]−\u03C9\u00B2[M])=0','Extract \u03C9\u1D63, {\u03C6\u1D63}, \u03B6\u1D63','Simulate response to any F(t)'],
            note:'Requires known m, k, c',
          },
          {
            x:316, w:268, color:'#c0392b', bg:'#FEF0F0', title:'Experimental Modal Analysis',
            sub:'Start from measurements',
            items:['Measure FRF: H(\u03C9)=X/F','Identify peaks \u2192 \u03C9\u1D63','Half-power BW \u2192 \u03B6\u1D63','Circle-fit \u2192 mode shapes','Validate / update model'],
            note:'No prior model needed',
          },
          {
            x:622, w:268, color:'#27ae60', bg:'#f0fff4', title:'Applications',
            sub:'What modal analysis enables',
            items:['Structural health monitoring','Resonance avoidance design','Model updating and validation','Forced response prediction','NVH (noise/vibration/harshness)'],
            note:'Foundation of modern dynamics',
          },
        ].map(({x,w,color,bg,title,sub,items,note}) => (
          <g key={x}>
            <rect x={x} y={10} width={w} height={H-20} rx={5} fill={bg} stroke={color} strokeWidth="1.5"/>
            <rect x={x} y={10} width={w} height={42} rx={5} fill={color}/>
            <rect x={x} y={36} width={w} height={16} fill={color}/>
            <text x={x+w/2} y={30} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{title}</text>
            <text x={x+w/2} y={46} textAnchor="middle" fontSize="10" fill="rgba(255,255,255,0.85)" fontStyle="italic">{sub}</text>
            {items.map((it,i) => (
              <g key={i}>
                <circle cx={x+18} cy={66+i*36} r={4} fill={color}/>
                <text x={x+28} y={70+i*36} fontSize="11" fill="#333">{it}</text>
              </g>
            ))}
            <rect x={x+10} y={270} width={w-20} height={28} rx={3} fill="rgba(255,255,255,0.7)" stroke={color} strokeWidth="1"/>
            <text x={x+w/2} y={288} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">{note}</text>
          </g>
        ))}

        {/* Bidirectional arrows between columns */}
        {[288,594].map((x,i) => (
          <g key={x}>
            <line x1={x} y1={160} x2={x+28} y2={160} stroke="#555" strokeWidth="2" markerEnd="url(#mGy)"/>
            <line x1={x+28} y1={170} x2={x} y2={170} stroke="#555" strokeWidth="2" markerEnd="url(#mGy)"/>
            <text x={x+14} y={155} textAnchor="middle" fontSize="9" fill="#888">{i===0?'validate':'predict'}</text>
            <text x={x+14} y={183} textAnchor="middle" fontSize="9" fill="#888">{i===0?'update':'verify'}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Modal analysis exists in two complementary forms. Analytical modal analysis starts from a mathematical model and computes the natural frequencies, damping ratios, and mode shapes. Experimental modal analysis (EMA) measures the structure's response and extracts the same quantities from test data. The two approaches validate and update each other, forming the complete workflow of structural dynamics practice.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 2 — Frequency Response Function (FRF): what it is
// ─────────────────────────────────────────────────────────────────
function DiagFRFExplained() {
  const W=900, H=400;
  const nPts=500, rMax=2.5;
  const z=0.08;
  const D  = (r,z) => 1/Math.sqrt((1-r*r)**2+(2*z*r)**2);
  const Ph = (r,z) => { let p=Math.atan2(2*z*r,1-r*r); return p<0?p+Math.PI:p; };

  // Panels: receptance, mobility, accelerance
  const types = [
    { label:'Receptance  H(ω) = X/F',  scale:(r,z)=>D(r,z),          ymax:8,   ylab:'|X/F|  [m/N]',   color:'#c0392b' },
    { label:'Mobility  H(ω) = V/F',     scale:(r,z)=>r*D(r,z),        ymax:6,   ylab:'|V/F|  [m/s/N]', color:'#2E75B6' },
    { label:'Accelerance  H(ω) = A/F',  scale:(r,z)=>r*r*D(r,z),      ymax:8,   ylab:'|A/F|  [m/s²/N]',color:'#27ae60' },
  ];

  const pW=252, fpH=200;
  const pmx = (r,px) => px+20+(r/rMax)*(pW-30);
  const pmy = (v,ymax,py) => py+15+(1-Math.min(v,ymax)/ymax)*fpH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Frequency Response Function (FRF) — Three Equivalent Forms</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* Three FRF type panels */}
        {types.map(({label,scale,ymax,ylab,color},pi) => {
          const px=10+pi*296;
          const py=14;
          const pts = Array.from({length:nPts+1},(_,i)=>{ const r=i/nPts*rMax; return [r,scale(r,z)]; });
          const d = pts.map(([r,v],i)=>`${i===0?'M':'L'}${pmx(r,px).toFixed(1)},${pmy(v,ymax,py).toFixed(1)}`).join(' ');

          return (
            <g key={pi}>
              <rect x={px} y={py} width={pW} height={fpH+65} rx={4} fill="#fff" stroke="#f0cece"/>
              <text x={px+pW/2} y={py+14} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{label}</text>

              {/* Graph area */}
              <rect x={px+18} y={py+20} width={pW-30} height={fpH} rx={3} fill="#fafafa" stroke="#ddd"/>

              {/* Grid */}
              {[0,2,4,6,ymax].filter((v,i,a)=>a.indexOf(v)===i).map(v=>(
                <g key={v}>
                  <line x1={px+18} y1={pmy(v,ymax,py)} x2={px+pW-12} y2={pmy(v,ymax,py)} stroke={v===0?'#ccc':'#ebebeb'} strokeWidth={v===1?1.5:0.7}/>
                  <text x={px+14} y={pmy(v,ymax,py)+4} textAnchor="end" fontSize="9" fill="#888">{v}</text>
                </g>
              ))}
              {[0,1,2].map(r=>(
                <g key={r}>
                  <line x1={pmx(r,px)} y1={py+20} x2={pmx(r,px)} y2={py+20+fpH} stroke={r===1?'#c0392b':'#ebebeb'} strokeWidth={r===1?1.2:0.6} strokeDasharray={r===1?'5,3':''}/>
                  <text x={pmx(r,px)} y={py+fpH+30} textAnchor="middle" fontSize="9" fill="#888">{r}</text>
                </g>
              ))}

              {/* FRF curve */}
              <path d={d} fill="none" stroke={color} strokeWidth="2.2"/>

              {/* Axis labels */}
              <line x1={px+16} y1={py+20} x2={px+16} y2={py+20+fpH} stroke="#555" strokeWidth="1.5"/>
              <line x1={px+16} y1={py+20+fpH} x2={px+pW-8} y2={py+20+fpH} stroke="#555" strokeWidth="1.5"/>
              <text x={px+pW/2} y={py+fpH+42} textAnchor="middle" fontSize="9" fill="#555">r = ω/ωₙ</text>
              <text x={px+8} y={py+20+fpH/2} textAnchor="middle" fontSize="9" fill={color} transform={`rotate(-90,${px+8},${py+20+fpH/2})`}>{ylab}</text>

              {/* Peak label */}
              {(() => {
                let rPk=0, vPk=0;
                for(let i=0;i<=nPts;i++){const r=i/nPts*rMax,v=scale(r,z);if(v>vPk){vPk=v;rPk=r;}}
                return (
                  <>
                    <circle cx={pmx(rPk,px)} cy={pmy(vPk,ymax,py)} r={4} fill={color} stroke="#fff" strokeWidth="1.5"/>
                    <line x1={pmx(rPk,px)} y1={pmy(vPk,ymax,py)} x2={pmx(rPk,px)} y2={py+20+fpH} stroke={color} strokeWidth="1" strokeDasharray="3"/>
                  </>
                );
              })()}
            </g>
          );
        })}

        {/* Bottom: FRF relationship and definition */}
        <rect x={10} y={286} width={880} height={104} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={304} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">FRF Definition and Relationships</text>

        {[
          {x:20,  bg:'#FEF0F0', bc:'#c0392b', w:202,
           lines:['Receptance (compliance):','H_d(\u03C9) = X(\u03C9)/F(\u03C9)','Units: m/N','Peaks at damped natural freq.']},
          {x:232, bg:'#eaf3ff', bc:'#2E75B6', w:202,
           lines:['Mobility (admittance):','H_v(\u03C9) = V(\u03C9)/F(\u03C9) = j\u03C9\u00B7H_d','Units: m/s/N','Peak shifts slightly from \u03C9\u2099']},
          {x:444, bg:'#f0fff4', bc:'#27ae60', w:202,
           lines:['Accelerance (inertance):','H_a(\u03C9) = A(\u03C9)/F(\u03C9) = -\u03C9\u00B2\u00B7H_d','Units: m/s\u00B2/N','Favoured in vibration testing']},
          {x:656, bg:'#fff5e6', bc:'#e07b00', w:234,
           lines:['Complex FRF:','H(\u03C9) = Re + j\u00B7Im','|H| = amplitude ratio','angle(H) = phase lag \u03C6']},
        ].map(({x,bg,bc,w,lines})=>(
          <g key={x}>
            <rect x={x+4} y={310} width={w} height={76} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {lines.map((l,i)=><text key={i} x={x+10} y={326+i*16} fontSize="10" fill={i===0?'#7B0D0D':'#444'} fontWeight={i===0?'700':'400'} fontFamily={i>0?"'Courier New',monospace":'inherit'}>{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The FRF H(ω) = output/input describes how a structure responds to a harmonic force at each frequency. Three equivalent forms differ only by powers of jω: receptance X/F (displacement/force), mobility V/F (velocity/force), and accelerance A/F (acceleration/force, most common in practice). All contain the same modal information. Peaks in |H(ω)| identify natural frequencies; the phase reveals damping.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 3 — FRF of a 3-DOF system: multiple peaks
// ─────────────────────────────────────────────────────────────────
function DiagMDOFFRF() {
  const W=900, H=360;

  // 3-DOF: modal superposition of three SDOF contributions
  // ω₁=1, ω₂=2.5, ω₃=4.5 rad/s (normalised), ζ=0.05 each
  // Modal residues (mode shapes at drive/response points) Aᵣ = φᵣ_drive × φᵣ_response
  const modes = [
    {ωn:1.0,  z:0.05, A:1.0,  color:'#2E75B6', label:'Mode 1'},
    {ωn:2.5,  z:0.05, A:0.6,  color:'#c0392b', label:'Mode 2'},
    {ωn:4.5,  z:0.05, A:0.35, color:'#27ae60', label:'Mode 3'},
  ];

  const ωmax=6, nPts=600;
  const combined = (ω) => {
    let re=0, im=0;
    modes.forEach(({ωn,z,A}) => {
      const r=ω/ωn, denom=(1-r*r)**2+(2*z*r)**2;
      re += A*(1-r*r)/denom;
      im += -A*(2*z*r)/denom;
    });
    return Math.sqrt(re*re+im*im);
  };
  const combinedPh = (ω) => {
    let re=0, im=0;
    modes.forEach(({ωn,z,A}) => {
      const r=ω/ωn, denom=(1-r*r)**2+(2*z*r)**2;
      re += A*(1-r*r)/denom;
      im += -A*(2*z*r)/denom;
    });
    let ph = Math.atan2(im, re); if(ph>0) ph-=Math.PI; return Math.abs(ph)*180/Math.PI;
  };

  const gX=50, gY=28, gW=520, gH=160;
  const phY=210, phH=100;
  const mx = ω => gX+(ω/ωmax)*gW;
  const myA = v => gY+(1-Math.min(v,12)/12)*gH;
  const myP = v => phY+(v/180)*phH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>FRF of a 3-DOF System — Modal Superposition &amp; Individual Contributions</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* Amplitude */}
        <text x={gX} y={gY-6} fontSize="11" fill="#7B0D0D" fontWeight="700">Amplitude |H(ω)| — combined and individual modes</text>
        <rect x={gX} y={gY} width={gW} height={gH} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Grid */}
        {[0,2,4,6,8,10,12].map(v=>(
          <g key={v}>
            <line x1={gX} y1={myA(v)} x2={gX+gW} y2={myA(v)} stroke={v===1?'#ccc':'#ebebeb'} strokeWidth="0.7"/>
            <text x={gX-5} y={myA(v)+4} textAnchor="end" fontSize="9" fill="#888">{v}</text>
          </g>
        ))}
        {[0,1,2,3,4,5,6].map(ω=>(
          <g key={ω}>
            <line x1={mx(ω)} y1={gY} x2={mx(ω)} y2={gY+gH} stroke="#ebebeb" strokeWidth="0.7"/>
            <text x={mx(ω)} y={gY+gH+12} textAnchor="middle" fontSize="9" fill="#888">{ω}</text>
          </g>
        ))}

        {/* Individual mode curves (dashed) */}
        {modes.map(({ωn,z,A,color,label}) => {
          const d = Array.from({length:nPts+1},(_,i)=>{
            const ω=i/nPts*ωmax;
            const r=ω/ωn, denom=(1-r*r)**2+(2*z*r)**2;
            const v=A/Math.sqrt(denom);
            return `${i===0?'M':'L'}${mx(ω).toFixed(1)},${myA(v).toFixed(1)}`;
          }).join(' ');
          return <path key={label} d={d} fill="none" stroke={color} strokeWidth="1.5" strokeDasharray="6,3" opacity="0.7"/>;
        })}

        {/* Combined curve */}
        <path d={Array.from({length:nPts+1},(_,i)=>{const ω=i/nPts*ωmax;return `${i===0?'M':'L'}${mx(ω).toFixed(1)},${myA(combined(ω)).toFixed(1)}`;}).join(' ')} fill="none" stroke="#1a1a2e" strokeWidth="2.5"/>

        {/* Peak annotations */}
        {modes.map(({ωn,color,label}) => (
          <g key={ωn}>
            <line x1={mx(ωn)} y1={gY} x2={mx(ωn)} y2={gY+gH} stroke={color} strokeWidth="1.5" strokeDasharray="4,3"/>
            <text x={mx(ωn)} y={gY-5} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">ω={ωn}</text>
            <circle cx={mx(ωn)} cy={myA(combined(ωn))} r={5} fill={color} stroke="#fff" strokeWidth="1.5"/>
          </g>
        ))}

        {/* Axes */}
        <line x1={gX-2} y1={gY} x2={gX-2} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <line x1={gX-2} y1={gY+gH} x2={gX+gW} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <text x={18} y={gY+gH/2} textAnchor="middle" fontSize="10" fill="#555" transform={`rotate(-90,18,${gY+gH})`}>|H(ω)|</text>

        {/* Phase */}
        <text x={gX} y={phY-7} fontSize="11" fill="#7B0D0D" fontWeight="700">Phase angle φ(ω)</text>
        <rect x={gX} y={phY} width={gW} height={phH} rx={3} fill="#fafafa" stroke="#ddd"/>
        {[0,90,180].map(v=>(
          <g key={v}>
            <line x1={gX} y1={myP(v)} x2={gX+gW} y2={myP(v)} stroke={v===90?'#ccc':'#ebebeb'} strokeWidth={v===90?1.2:0.7} strokeDasharray={v===90?'5,3':''}/>
            <text x={gX-5} y={myP(v)+4} textAnchor="end" fontSize="9" fill="#888">{v}°</text>
          </g>
        ))}
        {modes.map(({ωn,color}) => (
          <line key={ωn} x1={mx(ωn)} y1={phY} x2={mx(ωn)} y2={phY+phH} stroke={color} strokeWidth="1.2" strokeDasharray="4,3"/>
        ))}
        <path d={Array.from({length:nPts+1},(_,i)=>{const ω=i/nPts*ωmax;return `${i===0?'M':'L'}${mx(ω).toFixed(1)},${myP(combinedPh(ω)).toFixed(1)}`;}).join(' ')} fill="none" stroke="#9b59b6" strokeWidth="2"/>
        {/* 90° at each resonance */}
        {modes.map(({ωn,color}) => (
          <circle key={ωn} cx={mx(ωn)} cy={myP(90)} r={4} fill={color} stroke="#fff" strokeWidth="1.5"/>
        ))}
        <text x={mx(ωmax-0.1)} y={myP(90)} textAnchor="end" fontSize="9" fill="#9b59b6" fontWeight="700">90° at each ωₙ</text>

        <line x1={gX-2} y1={phY} x2={gX-2} y2={phY+phH} stroke="#555" strokeWidth="1.5"/>
        <line x1={gX-2} y1={phY+phH} x2={gX+gW} y2={phY+phH} stroke="#555" strokeWidth="1.5"/>
        {[1,2,3,4,5,6].map(ω=>(
          <g key={ω}><text x={mx(ω)} y={phY+phH+12} textAnchor="middle" fontSize="9" fill="#888">{ω}</text></g>
        ))}
        <text x={gX+gW/2} y={phY+phH+26} textAnchor="middle" fontSize="10" fill="#555">frequency ω (rad/s)</text>

        {/* RIGHT: legend and superposition explanation */}
        <rect x={580} y={10} width={310} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={735} y={26} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Modal Superposition</text>

        {/* Legend */}
        <line x1={590} y1={44} x2={618} y2={44} stroke="#1a1a2e" strokeWidth="2.5"/>
        <text x={624} y={48} fontSize="11" fill="#1a1a2e" fontWeight="700">Combined H(ω)</text>
        {modes.map(({color,label},i) => (
          <g key={i}>
            <line x1={590} y1={62+i*18} x2={618} y2={62+i*18} stroke={color} strokeWidth="2" strokeDasharray="6,3"/>
            <text x={624} y={66+i*18} fontSize="11" fill={color} fontWeight="700">{label} contribution</text>
          </g>
        ))}

        {/* Formula */}
        <rect x={588} y={122} width={296} height={64} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x={594} y={138} fontSize="12" fill="#7B0D0D" fontWeight="700">Modal superposition formula:</text>
        <text x={594} y={156} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">H(\u03C9) = \u03A3 Aᵣ/(\u03C9ₙᵣ\u00B2\u2212\u03C9\u00B2+2j\u03B6ᵣ\u03C9ₙᵣ\u03C9)</text>
        <text x={594} y={174} fontSize="10" fill="#555">Aᵣ = \u03C6ᵣ_drive \u00D7 \u03C6ᵣ_response (residue)</text>

        {/* Key observations */}
        {[
          {y:196, bg:'#eaf3ff', bc:'#2E75B6', t:'Between modes: interference',  d:'Modes add or cancel depending\non their relative phase'},
          {y:252, bg:'#f0fff4', bc:'#27ae60', t:'At each peak: one mode dominates', d:'Far from its resonance, a mode\ncontributes a small real offset'},
          {y:308, bg:'#fff5e6', bc:'#e07b00', t:'Anti-resonance dip',            d:'Destructive interference between\nadjacent modes can create minima'},
        ].map(({y,bg,bc,t,d}) => (
          <g key={y}>
            <rect x={588} y={y} width={296} height={50} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={594} y={y+16} fontSize="11" fill="#7B0D0D" fontWeight="700">{t}</text>
            {d.split('\n').map((l,i) => <text key={i} x={594} y={y+30+i*14} fontSize="10" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The FRF of a multi-DOF system is the sum of individual modal contributions. Each mode produces a peak at its natural frequency (dashed coloured curves); the measured FRF (black solid) is their complex sum. Phase passes through 90° at each natural frequency. Between modes, contributions interfere — potentially creating anti-resonance dips. This superposition structure is the foundation of all experimental modal analysis identification methods.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 4 — Modal parameter extraction: SDOF methods
// ─────────────────────────────────────────────────────────────────
function DiagSDOFExtraction() {
  const W=900, H=420;
  const zv=0.10, nPts=500;
  const Dfn  = (r) => 1/Math.sqrt((1-r*r)**2+(2*zv*r)**2);
  const Phfn = (r) => { let p=Math.atan2(2*zv*r,1-r*r); return p<0?p+Math.PI:p; };
  const rMax=2.2;

  const Dpk=Dfn(Math.sqrt(1-2*zv*zv));
  const Dhp=Dpk/Math.sqrt(2);
  let r1=0, r2=0;
  for(let i=1;i<=nPts;i++){
    const ra=(i-1)/nPts*rMax, rb=i/nPts*rMax;
    if(Dfn(ra)<Dhp&&Dfn(rb)>=Dhp&&ra<1)r1=rb;
    if(Dfn(ra)>=Dhp&&Dfn(rb)<Dhp&&ra>1)r2=ra;
  }

  // Panel coords
  const p1x=10,  p1w=270, p1y=14, p1h=H-20;
  const p2x=292, p2w=268;
  const p3x=572, p3w=318;

  // Amplitude/Phase graph coords (inside panel 1)
  const gX=p1x+36, gY=p1y+28, gW=p1w-48, gH=148;
  const phY=gY+gH+42, phH=98;
  const amx  = (r) => gX+(r/rMax)*gW;
  const aMyA = (v) => gY+(1-Math.min(v,8)/8)*gH;
  const aMyP = (v) => phY+(v/Math.PI)*phH;

  // Nyquist coords (inside panel 2)
  const nqCx=p2x+p2w/2, nqCy=p1y+p1h/2, nqR=88;
  const nqPts=[];
  for(let r=0;r<=rMax;r+=0.008){
    const D2=(1-r*r)**2+(2*zv*r)**2;
    nqPts.push([(1-r*r)/D2, -2*zv*r/D2]);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Modal Parameter Extraction — SDOF Methods</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── PANEL 1: Amplitude + Phase ── */}
        <rect x={p1x} y={p1y} width={p1w} height={p1h} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={p1x+p1w/2} y={p1y+16} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Methods 1 &amp; 2</text>

        {/* Amplitude graph */}
        <rect x={gX} y={gY} width={gW} height={gH} rx={3} fill="#fafafa" stroke="#ddd"/>
        {[0,2,4,6,8].map(v=>(
          <g key={v}>
            <line x1={gX} y1={aMyA(v)} x2={gX+gW} y2={aMyA(v)} stroke="#ebebeb" strokeWidth="0.7"/>
            <text x={gX-4} y={aMyA(v)+4} textAnchor="end" fontSize="9" fill="#888">{v}</text>
          </g>
        ))}
        {[0,0.5,1,1.5,2].map(r=>(
          <line key={r} x1={amx(r)} y1={gY} x2={amx(r)} y2={gY+gH}
            stroke={r===1?'#c0392b':'#ebebeb'} strokeWidth={r===1?1.2:0.7} strokeDasharray={r===1?'5,3':''}/>
        ))}
        <path d={Array.from({length:nPts+1},(_,i)=>{const r=i/nPts*rMax;return `${i===0?'M':'L'}${amx(r).toFixed(1)},${aMyA(Dfn(r)).toFixed(1)}`;}).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Peak */}
        <circle cx={amx(Math.sqrt(1-2*zv*zv))} cy={aMyA(Dpk)} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
        <line x1={amx(Math.sqrt(1-2*zv*zv))} y1={aMyA(Dpk)} x2={amx(Math.sqrt(1-2*zv*zv))} y2={gY+gH} stroke="#c0392b" strokeWidth="1" strokeDasharray="3"/>
        <text x={amx(Math.sqrt(1-2*zv*zv))+6} y={aMyA(Dpk)-6} fontSize="10" fill="#c0392b" fontWeight="700">{"\u2460 \u03C9\u2099 \u2248 \u03C9peak"}</text>

        {/* Half-power */}
        <line x1={amx(r1)} y1={aMyA(Dhp)} x2={amx(r2)} y2={aMyA(Dhp)} stroke="#27ae60" strokeWidth="2" markerEnd="url(#mG)"/>
        <line x1={amx(r2)} y1={aMyA(Dhp)} x2={amx(r1)} y2={aMyA(Dhp)} stroke="#27ae60" strokeWidth="2" markerEnd="url(#mG)"/>
        <circle cx={amx(r1)} cy={aMyA(Dhp)} r={4} fill="#27ae60" stroke="#fff" strokeWidth="1.5"/>
        <circle cx={amx(r2)} cy={aMyA(Dhp)} r={4} fill="#27ae60" stroke="#fff" strokeWidth="1.5"/>
        <text x={(amx(r1)+amx(r2))/2} y={aMyA(Dhp)-7} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">{"\u2461 \u03B6 = \u0394\u03C9 / (2\u03C9\u2099)"}</text>
        <line x1={amx(r1)} y1={aMyA(Dhp)+4} x2={amx(r1)} y2={gY+gH} stroke="#27ae60" strokeWidth="1" strokeDasharray="3"/>
        <line x1={amx(r2)} y1={aMyA(Dhp)+4} x2={amx(r2)} y2={gY+gH} stroke="#27ae60" strokeWidth="1" strokeDasharray="3"/>
        <text x={amx(r1)} y={gY+gH+12} textAnchor="middle" fontSize="9" fill="#27ae60">{"\u03C9\u2081"}</text>
        <text x={amx(r2)} y={gY+gH+12} textAnchor="middle" fontSize="9" fill="#27ae60">{"\u03C9\u2082"}</text>

        {/* Amplitude axes */}
        <line x1={gX-2} y1={gY} x2={gX-2} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <line x1={gX-2} y1={gY+gH} x2={gX+gW} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <text x={gX-18} y={gY+gH/2+4} textAnchor="middle" fontSize="10" fill="#555" transform={`rotate(-90,${gX-18},${gY+gH/2})`}>|H|</text>

        {/* Phase graph */}
        <text x={p1x+p1w/2} y={phY-8} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">{"Phase \u03C6(r)"}</text>
        <rect x={gX} y={phY} width={gW} height={phH} rx={3} fill="#fafafa" stroke="#ddd"/>
        {[0,90,180].map(v=>(
          <g key={v}>
            <line x1={gX} y1={aMyP(v*Math.PI/180)} x2={gX+gW} y2={aMyP(v*Math.PI/180)}
              stroke={v===90?'#ccc':'#ebebeb'} strokeWidth={v===90?1.2:0.7} strokeDasharray={v===90?'5,3':''}/>
            <text x={gX-4} y={aMyP(v*Math.PI/180)+4} textAnchor="end" fontSize="9" fill="#888">{v}{"\u00B0"}</text>
          </g>
        ))}
        <path d={Array.from({length:nPts+1},(_,i)=>{const r=i/nPts*rMax;return `${i===0?'M':'L'}${amx(r).toFixed(1)},${aMyP(Phfn(r)).toFixed(1)}`;}).join(' ')}
          fill="none" stroke="#9b59b6" strokeWidth="2.2"/>

        {/* 90-deg */}
        <circle cx={amx(1)} cy={aMyP(Math.PI/2)} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
        <text x={amx(1)+6} y={aMyP(Math.PI/2)-5} fontSize="10" fill="#c0392b" fontWeight="700">{"\u2462 90\u00B0 \u2192 \u03C9\u2099"}</text>

        {/* Phase slope */}
        {(()=>{
          const r0=0.82, r3=1.18;
          const y0=aMyP(Phfn(r0)), y3=aMyP(Phfn(r3));
          return(
            <>
              <line x1={amx(r0)} y1={y0} x2={amx(r3)} y2={y3} stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#mO)"/>
              <text x={amx(r0)-2} y={y0-5} textAnchor="end" fontSize="10" fill="#e07b00" fontWeight="700">{"\u2463 slope \u221d 1/\u03B6"}</text>
            </>
          );
        })()}

        {/* Phase axes */}
        <line x1={gX-2} y1={phY} x2={gX-2} y2={phY+phH} stroke="#555" strokeWidth="1.5"/>
        <line x1={gX-2} y1={phY+phH} x2={gX+gW} y2={phY+phH} stroke="#555" strokeWidth="1.5"/>
        {[0,0.5,1,1.5,2].map(r=>(
          <g key={r}>
            <line x1={amx(r)} y1={phY+phH} x2={amx(r)} y2={phY+phH+4} stroke="#555" strokeWidth="1.5"/>
            <text x={amx(r)} y={phY+phH+14} textAnchor="middle" fontSize="9" fill="#888">{r}</text>
          </g>
        ))}
        <text x={gX+gW/2} y={phY+phH+28} textAnchor="middle" fontSize="10" fill="#555">{"r = \u03C9/\u03C9\u2099"}</text>

        {/* ── PANEL 2: Nyquist ── */}
        <rect x={p2x} y={p1y} width={p2w} height={p1h} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={p2x+p2w/2} y={p1y+16} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Method 3: Nyquist</text>

        <rect x={p2x+6} y={p1y+24} width={p2w-12} height={p1h-30} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Nyquist axes */}
        <line x1={p2x+12} y1={nqCy} x2={p2x+p2w-8} y2={nqCy} stroke="#aaa" strokeWidth="1.2"/>
        <line x1={nqCx} y1={p1y+30} x2={nqCx} y2={p1y+p1h-10} stroke="#aaa" strokeWidth="1.2"/>
        <text x={p2x+p2w-10} y={nqCy-4} fontSize="10" fill="#888">Re</text>
        <text x={nqCx+4} y={p1y+38} fontSize="10" fill="#888">Im</text>

        {/* Circle path */}
        <path d={nqPts.map(([re,im],i)=>`${i===0?'M':'L'}${(nqCx+re*nqR).toFixed(1)},${(nqCy+im*nqR).toFixed(1)}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Key points */}
        {[
          {r:0,   col:'#2E75B6', note:'r=0'},
          {r:1,   col:'#c0392b', note:'r=1 (\u03C9\u2099)'},
          {r:1.9, col:'#27ae60', note:'r=1.9'},
        ].map(({r,col,note})=>{
          const D2=(1-r*r)**2+(2*zv*r)**2;
          const re=(1-r*r)/D2, im=-2*zv*r/D2;
          const cx2=nqCx+re*nqR, cy2=nqCy+im*nqR;
          const tx=r===0?cx2-8:cx2+8, ta=r===0?'end':'start';
          const ty=r===1?cy2+14:cy2-6;
          return(
            <g key={r}>
              <circle cx={cx2} cy={cy2} r={5} fill={col} stroke="#fff" strokeWidth="1.5"/>
              <text x={tx} y={ty} textAnchor={ta} fontSize="10" fill={col} fontWeight="700">{note}</text>
            </g>
          );
        })}

        {/* Diameter */}
        <line x1={nqCx-8} y1={nqCy-nqR+6} x2={nqCx-8} y2={nqCy-4} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="3" markerEnd="url(#mB)"/>
        <line x1={nqCx-8} y1={nqCy-4} x2={nqCx-8} y2={nqCy-nqR+6} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="3" markerEnd="url(#mB)"/>
        <text x={nqCx-12} y={(nqCy-nqR/2)} textAnchor="end" fontSize="10" fill="#2E75B6" fontWeight="700">{"d=1/(c\u03C9\u2099)"}</text>

        {/* Info boxes inside Nyquist panel */}
        {[
          {y:p1y+p1h-120, bg:'#FEF0F0', bc:'#c0392b',  lines:['SDOF locus = circle','Radius \u221d 1/(2c\u03C9\u2099)']},
          {y:p1y+p1h-72,  bg:'#eaf3ff', bc:'#2E75B6',  lines:['\u03C9\u2099 at top of circle (max Im)']},
          {y:p1y+p1h-34,  bg:'#f0fff4', bc:'#27ae60',  lines:['Diameter \u2192 damping coeff. c']},
        ].map(({y,bg,bc,lines})=>(
          <g key={y}>
            <rect x={p2x+10} y={y} width={p2w-20} height={lines.length*15+10} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {lines.map((l,i)=><text key={i} x={p2x+16} y={y+14+i*15} fontSize="10" fill="#333">{l}</text>)}
          </g>
        ))}

        {/* ── PANEL 3: Steps ── */}
        <rect x={p3x} y={p1y} width={p3w} height={p1h} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={p3x+p3w/2} y={p1y+16} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Extraction Steps</text>

        {[
          {n:'①', c:'#c0392b', t:'\u03C9\u2099 from peak',    d:'\u03C9 at max |H(\u03C9)|'},
          {n:'②', c:'#27ae60', t:'\u03B6 from bandwidth',    d:'\u03B6 = \u0394\u03C9 / (2\u03C9\u2099)'},
          {n:'③', c:'#9b59b6', t:'\u03C9\u2099 from phase',   d:'Phase = 90\u00B0 crossing'},
          {n:'④', c:'#e07b00', t:'\u03B6 from slope',        d:'d\u03C6/d\u03C9 at \u03C9\u2099'},
          {n:'⑤', c:'#2E75B6', t:'Circle-fit',          d:'Nyquist diameter \u2192 c'},
          {n:'⑥', c:'#555',    t:'Residue A',           d:'|H(\u03C9\u2099)|\u00D72\u03B6\u03C9\u2099\u00B2 = |A|'},
        ].map(({n,c,t,d},i)=>{
          const iy=p1y+26+i*60;
          return(
            <g key={i}>
              <rect x={p3x+10} y={iy} width={p3w-20} height={52} rx={4} fill="#fafafa" stroke={c} strokeWidth="1.2"/>
              <circle cx={p3x+28} cy={iy+18} r={12} fill={c}/>
              <text x={p3x+28} y={iy+23} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{n}</text>
              <text x={p3x+46} y={iy+17} fontSize="12" fill="#7B0D0D" fontWeight="700">{t}</text>
              <text x={p3x+46} y={iy+33} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">{d}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        {"Three SDOF extraction methods. \u2460\u03C9n from amplitude peak. \u2461\u03B6 from half-power bandwidth (\u03C92\u2212\u03C91)/(2\u03C9n). \u2462\u03C9n from exact 90\u00B0 phase crossing — most reliable. \u2463\u03B6 from phase slope at resonance (steeper = lower damping). \u2464 Nyquist circle-fit: Im(H) vs Re(H) traces a circle; \u03C9n at top, diameter gives damping coefficient directly."}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 5 — Experimental setup: instrumentation chain
// ─────────────────────────────────────────────────────────────────
function DiagExperimentalSetup() {
  const W=900, H=320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Experimental Modal Analysis — Instrumentation Chain &amp; Test Setup</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── Structure being tested ── */}
        <rect x={10} y={10} width={W-20} height={145} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Test Setup — Structure Under Test with Instrumentation</text>

        {/* Structure (beam on supports) */}
        <polygon points="80,90 90,112 70,112" fill="#888"/>
        <line x1={70} y1={112} x2={90} y2={112} stroke="#888" strokeWidth="2"/>
        <polygon points="400,90 410,112 390,112" fill="#888"/>
        <line x1={390} y1={112} x2={410} y2={112} stroke="#888" strokeWidth="2"/>
        <rect x={80} y={78} width={320} height={14} rx={2} fill="#8B6914" stroke="#5a4208" strokeWidth="2"/>

        {/* Impact hammer */}
        <rect x={28} y={58} width={28} height={14} rx={3} fill="#e07b00" stroke="#b7510a" strokeWidth="2"/>
        <rect x={12} y={61} width={16} height={8} rx={2} fill="#888"/>
        <line x1={56} y1={65} x2={82} y2={78} stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#mO)"/>
        <text x={34} y={54} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">Impact</text>
        <text x={34} y={43} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">hammer</text>
        <text x={34} y={131} textAnchor="middle" fontSize="9" fill="#888">Force F(t)</text>

        {/* Accelerometers on beam */}
        {[130,220,310].map((xp,i) => (
          <g key={i}>
            <rect x={xp-10} y={59} width={20} height={18} rx={2} fill="#9b59b6" stroke="#6c3483" strokeWidth="1.5"/>
            <text x={xp} y={52} textAnchor="middle" fontSize="9" fill="#9b59b6" fontWeight="700">acc{i+1}</text>
            <line x1={xp} y1={59} x2={xp} y2={78} stroke="#9b59b6" strokeWidth="1.5"/>
          </g>
        ))}

        {/* Shaker alternative */}
        <rect x={462} y={62} width={30} height={24} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <rect x={492} y={69} width={18} height={10} rx={2} fill="#888"/>
        <line x1={510} y1={74} x2={520} y2={80} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#mB)"/>
        <text x={477} y={57} textAnchor="middle" fontSize="9" fill="#2E75B6" fontWeight="700">OR shaker</text>
        <text x={477} y={46} textAnchor="middle" fontSize="9" fill="#2E75B6" fontWeight="700">electro-</text>
        <text x={477} y={35} textAnchor="middle" fontSize="9" fill="#2E75B6" fontWeight="700">dynamic</text>

        {/* Cables to DAQ */}
        {[130,220,310].map(xp => (
          <line key={xp} x1={xp} y1={77} x2={xp} y2={140} stroke="#9b59b6" strokeWidth="1.5" strokeDasharray="3,2"/>
        ))}
        <line x1={52} y1={78} x2={80} y2={140} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="3,2"/>

        {/* DAQ box */}
        <rect x={50} y={130} width={330} height={22} rx={4} fill="#555" stroke="#333" strokeWidth="1.5"/>
        <text x={215} y={145} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Data Acquisition System (DAQ) — simultaneous sampling of all channels</text>

        {/* Signal chain boxes */}
        {[
          {x:520, label:'Signal\nConditioner', color:'#27ae60'},
          {x:618, label:'A/D\nConverter', color:'#e07b00'},
          {x:716, label:'FFT\nAnalyser', color:'#9b59b6'},
          {x:814, label:'Modal\nSoftware', color:'#c0392b'},
        ].map(({x,label,color}) => (
          <g key={x}>
            <rect x={x} y={60} width={82} height={50} rx={4} fill={color} opacity="0.15" stroke={color} strokeWidth="1.5"/>
            {label.split('\n').map((l,i)=>(
              <text key={i} x={x+41} y={80+i*15} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">{l}</text>
            ))}
          </g>
        ))}
        {[520,618,716].map(x => (
          <line key={x} x1={x+82} y1={85} x2={x+98} y2={85} stroke="#555" strokeWidth="1.5" markerEnd="url(#mGy)"/>
        ))}
        <text x={715} y={122} textAnchor="middle" fontSize="9" fill="#555">H(ω)=FFT(x)/FFT(F)</text>

        {/* ── Bottom: measurement types ── */}
        <rect x={10} y={162} width={W-20} height={148} rx={5} fill="#fafafa" stroke="#f0cece"/>
        <text x={450} y={180} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Excitation Strategies &amp; Measurement Considerations</text>

        {[
          {x:18,  w:200, color:'#e07b00', bg:'#fff5e6', title:'Impact Hammer',
           pts:['Broadband excitation in one hit','Portable, fast, no attachment','Force window + exponential window','Risk: double-impact, poor coherence','Best for: lightly-damped structures']},
          {x:228, w:200, color:'#2E75B6', bg:'#eaf3ff', title:'Electrodynamic Shaker',
           pts:['Controlled spectrum (swept sine/random)','Stinger rod avoids mass loading','Burst random for leakage control','Slower but better coherence','Best for: broad frequency range']},
          {x:438, w:210, color:'#27ae60', bg:'#f0fff4', title:'Reciprocity & Averaging',
           pts:['Maxwell reciprocity: H_ij = H_ji','Average n_avg spectra per measurement','Reduces random noise by 1/\u221A(n_avg)','Coherence \u03B3\u00B2 \u2265 0.9 required','Check with multiple averages']},
          {x:658, w:232, color:'#c0392b', bg:'#FEF0F0', title:'Test Considerations',
           pts:['Boundary conditions must be defined','Free-free: suspend on soft bungees','Fixed: bolt rigidly to test rig','Mass loading: accelerometer < 1% mass','Signal windows: Hann, force, exponential']},
        ].map(({x,w,color,bg,title,pts}) => (
          <g key={x}>
            <rect x={x+4} y={188} width={w} height={116} rx={4} fill={bg} stroke={color} strokeWidth="1.2"/>
            <text x={x+10} y={204} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {pts.map((p,i)=>(
              <g key={i}>
                <circle cx={x+12} cy={216+i*18} r={3} fill={color}/>
                <text x={x+20} y={220+i*18} fontSize="9" fill="#333">{p}</text>
              </g>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        A complete EMA test chain: excitation (impact hammer or shaker) → force transducer → structure under test → accelerometers → signal conditioners → A/D converter → FFT analyser → modal identification software. Key outputs are the FRF matrix H(ω). The fundamental theorem (Maxwell reciprocity) states H_ij = H_ji, halving measurement effort. Signal quality is monitored using coherence γ² — values below 0.9 indicate noise, nonlinearity, or leakage.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 6 — Mode shape animation snapshot (3-DOF beam)
// ─────────────────────────────────────────────────────────────────
function DiagModeShapeVisualization() {
  const W=900, H=380;

  // 5-node beam, 3 modes
  // Mode shapes for a free-free beam (approximate)
  const nodes = [0,1,2,3,4]; // positions 0..1
  const modes = [
    {
      label:'Mode 1 — 1st Bending', ω:'ω₁', color:'#2E75B6',
      // first bending: sine half-wave
      shapes: nodes.map(x => Math.sin(Math.PI*(x/4))),
      desc:'Fundamental bending mode. All points on same side. 0 nodes.',
    },
    {
      label:'Mode 2 — 2nd Bending', ω:'ω₂', color:'#c0392b',
      // second bending: sine full wave
      shapes: nodes.map(x => Math.sin(2*Math.PI*(x/4))),
      desc:'Second bending mode. Points alternate sign. 1 internal node.',
    },
    {
      label:'Mode 3 — 3rd Bending', ω:'ω₃', color:'#27ae60',
      // third bending: sine 3/2 wave
      shapes: nodes.map(x => Math.sin(3*Math.PI*(x/4))),
      desc:'Third bending mode. 2 internal nodes. Higher frequency.',
    },
  ];

  const panW=260, panH=180;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Mode Shape Visualization — 5-Node Beam, Three Bending Modes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* Three mode shape panels */}
        {modes.map(({label,ω,color,shapes,desc},mi) => {
          const px=10+mi*296, py=10;
          const nodeX = nodes.map(n => px+30+n*(panW-50)/4);
          const eqY = py+panH/2+20;
          const scale=54;

          // Smooth curve through nodes
          const curvePts=[];
          for(let t=0;t<=200;t++) {
            const frac=t/200;
            const xi=frac*(nodes.length-1);
            const i=Math.min(Math.floor(xi),nodes.length-2);
            const f=xi-i;
            // cubic interpolation (simple lerp for now)
            const y=shapes[i]*(1-f)+shapes[i+1]*f;
            curvePts.push([px+30+frac*(panW-50), eqY-y*scale]);
          }

          return (
            <g key={mi}>
              <rect x={px} y={py} width={panW} height={panH+80} rx={5} fill="#fff" stroke={color} strokeWidth="1.5"/>
              <rect x={px} y={py} width={panW} height={26} rx={5} fill={color}/>
              <rect x={px} y={py+18} width={panW} height={8} fill={color}/>
              <text x={px+panW/2} y={py+17} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{label}</text>

              {/* Equilibrium line */}
              <line x1={px+28} y1={eqY} x2={px+panW-18} y2={eqY} stroke="#ddd" strokeWidth="1.5" strokeDasharray="5,3"/>

              {/* Mode shape curve */}
              <path d={curvePts.map(([x,y],i)=>`${i===0?'M':'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ')} fill="none" stroke={color} strokeWidth="2.5"/>

              {/* Node points */}
              {shapes.map((amp,ni) => {
                const nx=nodeX[ni];
                const ny=eqY-amp*scale;
                const isNode=Math.abs(amp)<0.01;
                return (
                  <g key={ni}>
                    {/* Displacement arrow */}
                    {Math.abs(amp)>0.05 && (
                      <line x1={nx} y1={eqY} x2={nx} y2={ny}
                        stroke={color} strokeWidth="2"
                        markerEnd={amp>0?'url(#mG)':'url(#mR)'} opacity="0.6"/>
                    )}
                    {/* Mass circle */}
                    <circle cx={nx} cy={ny} r={10} fill={isNode?'#fff':color} stroke={color} strokeWidth="2"/>
                    <text x={nx} y={ny+4} textAnchor="middle" fontSize="9" fill={isNode?color:'#fff'} fontWeight="700">{ni+1}</text>
                    {/* Node marker */}
                    {isNode && <text x={nx} y={eqY+18} textAnchor="middle" fontSize="9" fill={color} fontWeight="700">NODE</text>}
                  </g>
                );
              })}

              {/* Mirrored ghost (negative half of oscillation) */}
              <path d={curvePts.map(([x,y],i)=>`${i===0?'M':'L'}${x.toFixed(1)},${(2*eqY-y).toFixed(1)}`).join(' ')} fill="none" stroke={color} strokeWidth="1.2" strokeDasharray="6,4" opacity="0.3"/>

              {/* Frequency label */}
              <text x={px+panW/2} y={py+panH+18} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{ω}</text>

              {/* Description */}
              <text x={px+8} y={py+panH+38} fontSize="10" fill="#555">{desc}</text>

              {/* Node count */}
              <rect x={px+8} y={py+panH+52} width={panW-16} height={30} rx={3} fill="rgba(255,255,255,0.8)" stroke={color} strokeWidth="1"/>
              <text x={px+14} y={py+panH+68} fontSize="10" fill={color} fontWeight="700">Nodes: {mi}  |  Mode number: {mi+1}</text>
            </g>
          );
        })}

        {/* Bottom: mode shape properties summary */}
        <rect x={10} y={272} width={880} height={98} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={290} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Mode Shape Properties &amp; Uses</text>

        {[
          {x:18,  w:210, bg:'#eaf3ff', bc:'#2E75B6', title:'Properties',
           lines:['Mode r has r−1 internal nodes','All masses at same freq. in a mode','Amplitude is arbitrary — only ratio matters','Orthogonal to all other mode shapes']},
          {x:238, w:210, bg:'#f0fff4', bc:'#27ae60', title:'Measuring mode shapes',
           lines:['Measure H\u1D62\u2C7C at fixed j, vary i (roving acc.)','Or roving hammer, fixed response','|H\u1D62\u2C7C(ωᵣ)| \u221D |\u03C6ᵢᵣ| at resonance ωᵣ','Sign from phase: 0°=same, 180°=opposite']},
          {x:458, w:210, bg:'#FEF0F0', bc:'#c0392b', title:'Model validation',
           lines:['MAC (Modal Assurance Criterion)','MAC = (\u03C6_A\u1D40\u03C6_X)\u00B2/(\u03C6_A\u1D40\u03C6_A)(\u03C6_X\u1D40\u03C6_X)','MAC=1.0: perfect match','MAC<0.9: mode shape mismatch']},
          {x:678, w:212, bg:'#fff5e6', bc:'#e07b00', title:'Model updating',
           lines:['Compare analytical \u03C9ᵣ,\u03C6ᵣ to measured','Adjust k,m,c to minimise difference','Sensitivity-based updating: \u0394p=-S\u207B\u00B9\u0394r','Validated model used for prediction']},
        ].map(({x,w,bg,bc,title,lines}) => (
          <g key={x}>
            <rect x={x+2} y={298} width={w} height={68} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={x+8} y={314} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i) => <text key={i} x={x+8} y={328+i*14} fontSize="9" fill="#333">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Three bending mode shapes of a 5-node free-free beam. Solid curves show the mode shape; dashed curves show the mirror image (opposite phase at half-cycle). Mode 1 has no internal nodes — all masses move together; mode 2 has one node; mode 3 has two. Measuring mode shapes experimentally requires FRF measurements at every response DOF. The Modal Assurance Criterion (MAC) quantifies how well experimental and analytical mode shapes agree.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 7 — MDOF FRF identification: SIMO and poly reference
// ─────────────────────────────────────────────────────────────────
function DiagMDOFIdentification() {
  const W=900, H=360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Multi-Mode Identification Methods — From SDOF to Global Curve-Fitting</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* Method progression: 4 cards */}
        {[
          {
            x:10, w:208, color:'#2E75B6', bg:'#eaf3ff',
            title:'SDOF Local\n(Peak-Picking)',
            steps:['Process one peak at a time','Isolate region around each ωᵣ','Apply half-power or circle-fit','Simple, fast, less accurate','Problem: mode overlap errors'],
            acc:'Accuracy: ★★☆☆☆',
          },
          {
            x:228, w:208, color:'#27ae60', bg:'#f0fff4',
            title:'SDOF Global\n(One-at-a-time)',
            steps:['Identify each mode globally','Use all measurement points','Average ωᵣ, ζᵣ across FRFs','Consistent modal parameters','Problem: still serial per mode'],
            acc:'Accuracy: ★★★☆☆',
          },
          {
            x:446, w:208, color:'#e07b00', bg:'#fff5e6',
            title:'MDOF Poly-ref\n(Global Curve-Fit)',
            steps:['Fit all modes simultaneously','Minimise error over full band','Rational fraction polynomial','Handles mode overlap well','Output: all ωᵣ, ζᵣ, {φᵣ} at once'],
            acc:'Accuracy: ★★★★☆',
          },
          {
            x:664, w:226, color:'#c0392b', bg:'#FEF0F0',
            title:'Stochastic Sub-space\n(SSI — operational)',
            steps:['No applied excitation needed','Output-only: ambient vibration','State-space model from data','Stabilisation diagram selects modes','Used for bridges, buildings in-service'],
            acc:'Accuracy: ★★★★★',
          },
        ].map(({x,w,color,bg,title,steps,acc}) => (
          <g key={x}>
            <rect x={x} y={10} width={w} height={H-20} rx={5} fill={bg} stroke={color} strokeWidth="1.5"/>
            <rect x={x} y={10} width={w} height={38} rx={5} fill={color}/>
            <rect x={x} y={32} width={w} height={16} fill={color}/>
            {title.split('\n').map((l,i) => (
              <text key={i} x={x+w/2} y={26+i*15} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{l}</text>
            ))}
            {steps.map((s,i) => (
              <g key={i}>
                <circle cx={x+14} cy={60+i*38} r={4} fill={color}/>
                <text x={x+24} y={64+i*38} fontSize="10" fill="#333">{s}</text>
              </g>
            ))}
            <rect x={x+8} y={H-50} width={w-16} height={26} rx={3} fill="rgba(255,255,255,0.8)" stroke={color} strokeWidth="1"/>
            <text x={x+w/2} y={H-33} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">{acc}</text>
          </g>
        ))}

        {/* Arrows showing progression */}
        {[218,436,654].map(x => (
          <g key={x}>
            <polygon points={`${x},175 ${x+10},185 ${x},195 ${x+10},185`} fill="#aaa"/>
          </g>
        ))}

        {/* Stabilisation diagram at bottom */}
        <rect x={10} y={310} width={880} height={40} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={326} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Stabilisation Diagram (used in polyreference &amp; SSI methods)</text>
        <text x={450} y={344} textAnchor="middle" fontSize="11" fill="#555">Increase model order n. Plot poles at each order. Stable poles (same ω, ζ across orders) are physical modes. Unstable poles are mathematical artefacts. Select stable columns.</text>
      </svg>
      <div style={S.dCaption}>
        Modal identification methods form a progression from simple to rigorous. SDOF local methods (peak-picking, circle-fit) are fast but fail when modes overlap. Global MDOF methods (polyreference, rational fraction polynomial) fit all modes simultaneously, handling overlap and yielding consistent parameters across all measurement points. Stochastic Subspace Identification (SSI) requires no artificial excitation — it extracts modal parameters from the structure's response to ambient loading, enabling in-service monitoring of bridges and buildings.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 8 — Model updating: MAC matrix and frequency comparison
// ─────────────────────────────────────────────────────────────────
function DiagModelUpdating() {
  const W=900, H=340;
  const n=4;

  // Synthetic MAC matrix (4 modes): analytical vs experimental
  // Good match on diagonal, poor on off-diagonal
  const macBefore = [
    [0.96, 0.08, 0.04, 0.02],
    [0.11, 0.71, 0.09, 0.05],
    [0.03, 0.07, 0.83, 0.11],
    [0.01, 0.04, 0.08, 0.88],
  ];
  const macAfter = [
    [0.99, 0.01, 0.00, 0.01],
    [0.02, 0.97, 0.02, 0.01],
    [0.00, 0.01, 0.96, 0.02],
    [0.01, 0.01, 0.02, 0.98],
  ];

  const csz=52;

  const MacMatrix = ({mac, x, y, title}) => (
    <g>
      <text x={x+n*csz/2} y={y-6} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
      {mac.map((row,ri) => row.map((val,ci) => {
        const alpha=val, red=Math.round(192*alpha), blue=Math.round(192*(1-alpha));
        const fill=`rgb(${red},${Math.round(192*(1-Math.abs(alpha-0.5)*2))},${blue})`;
        const tc=val>0.5?'#fff':'#333';
        return (
          <g key={`${ri}${ci}`}>
            <rect x={x+ci*csz} y={y+ri*csz} width={csz-2} height={csz-2} rx={2} fill={fill}/>
            <text x={x+ci*csz+csz/2-1} y={y+ri*csz+csz/2+4} textAnchor="middle" fontSize="11" fill={tc} fontWeight="700">{val.toFixed(2)}</text>
          </g>
        );
      }))}
      {/* Axis labels */}
      {['φ₁','φ₂','φ₃','φ₄'].map((l,i) => (
        <g key={i}>
          <text x={x+i*csz+csz/2-1} y={y+n*csz+14} textAnchor="middle" fontSize="10" fill="#555">{l}</text>
          <text x={x-8} y={y+i*csz+csz/2+4} textAnchor="end" fontSize="10" fill="#555">{l}</text>
        </g>
      ))}
      <text x={x+n*csz/2} y={y+n*csz+28} textAnchor="middle" fontSize="10" fill="#555">Analytical modes</text>
      <text x={x-34} y={y+n*csz/2} textAnchor="middle" fontSize="10" fill="#555" transform={`rotate(-90,${x-34},${y+n*csz/2})`}>Experimental</text>
    </g>
  );

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Model Validation &amp; Updating — MAC Matrix and Frequency Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* MAC before updating */}
        <rect x={10} y={10} width={320} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={165} y={30} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">Before Model Updating</text>
        <MacMatrix mac={macBefore} x={60} y={46} title="MAC matrix (before)"/>

        {/* Arrow */}
        <line x1={330} y1={170} x2={370} y2={170} stroke="#555" strokeWidth="2.5" markerEnd="url(#mGy)"/>
        <text x={350} y={162} textAnchor="middle" fontSize="10" fill="#555" fontWeight="700">update</text>
        <text x={350} y={182} textAnchor="middle" fontSize="10" fill="#555">k, m, c</text>

        {/* MAC after */}
        <rect x={374} y={10} width={318} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={533} y={30} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">After Model Updating</text>
        <MacMatrix mac={macAfter} x={422} y={46} title="MAC matrix (after)"/>

        {/* Right: interpretation + frequency table */}
        <rect x={700} y={10} width={190} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={795} y={28} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Frequency Comparison</text>

        {/* Frequency bar chart */}
        {['Mode 1','Mode 2','Mode 3','Mode 4'].map((lbl,i) => {
          const yp=44+i*52;
          const fAnalBefore=[12.1,28.4,55.2,88.9][i];
          const fExp=[10.8,26.1,51.7,85.2][i];
          const fAnalAfter=[10.9,26.3,51.9,85.4][i];
          const sc=1.6;
          return (
            <g key={i}>
              <text x={706} y={yp+10} fontSize="10" fill="#555" fontWeight="700">{lbl}</text>
              {/* Experimental bar (reference) */}
              <rect x={706} y={yp+14} width={fExp*sc} height={10} rx={2} fill="#9b59b6" opacity="0.8"/>
              <text x={706+fExp*sc+2} y={yp+23} fontSize="9" fill="#9b59b6">{fExp}Hz (exp)</text>
              {/* Before bar */}
              <rect x={706} y={yp+26} width={fAnalBefore*sc} height={8} rx={2} fill="#c0392b" opacity="0.6"/>
              <text x={706+fAnalBefore*sc+2} y={yp+34} fontSize="9" fill="#c0392b">{fAnalBefore} (before)</text>
              {/* After bar */}
              <rect x={706} y={yp+36} width={fAnalAfter*sc} height={8} rx={2} fill="#27ae60" opacity="0.8"/>
              <text x={706+fAnalAfter*sc+2} y={yp+44} fontSize="9" fill="#27ae60">{fAnalAfter} (after)</text>
            </g>
          );
        })}

        {/* Legend */}
        {[{c:'#9b59b6',l:'Experimental'},{c:'#c0392b',l:'FEA before'},{c:'#27ae60',l:'FEA after'}].map(({c,l},i) => (
          <g key={i}>
            <rect x={706} y={260+i*18} width={16} height={10} rx={2} fill={c} opacity="0.8"/>
            <text x={726} y={269+i*18} fontSize="9" fill="#444">{l}</text>
          </g>
        ))}

        {/* MAC color scale */}
        {[0,0.2,0.4,0.6,0.8,1.0].map((v,i) => {
          const alpha=v, r2=Math.round(192*alpha), b=Math.round(192*(1-alpha));
          return (
            <g key={i}>
              <rect x={706+i*20} y={308} width={18} height={12} fill={`rgb(${r2},${Math.round(192*(1-Math.abs(v-0.5)*2))},${b})`}/>
              <text x={706+i*20+9} y={330} textAnchor="middle" fontSize="8" fill="#555">{v}</text>
            </g>
          );
        })}
        <text x={795} y={344} textAnchor="middle" fontSize="9" fill="#555" fontStyle="italic">MAC colour scale (0=no match, 1=perfect)</text>
      </svg>
      <div style={S.dCaption}>
        The MAC (Modal Assurance Criterion) matrix compares analytical and experimental mode shapes. A perfect model gives MAC=1 on the diagonal and 0 elsewhere. Before updating (left), diagonal values below 0.9 and non-zero off-diagonal terms indicate model error. After updating stiffness and mass parameters (right), MAC values improve to 0.97–0.99. The frequency comparison shows the updated FEA model matching experimental natural frequencies to within 0.2%.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 9 — Complete modal analysis workflow
// ─────────────────────────────────────────────────────────────────
function DiagWorkflow() {
  const W=900, H=300;
  const steps = [
    {n:'1', color:'#2E75B6', bg:'#eaf3ff', title:'Define\nTest Plan',     lines:['DOF selection','Boundary cond.','Sensor locations','Excitation type']},
    {n:'2', color:'#27ae60', bg:'#f0fff4', title:'Acquire\nFRF Data',      lines:['Excite structure','Measure H(ω)','Check coherence','Average signals']},
    {n:'3', color:'#c0392b', bg:'#FEF0F0', title:'Identify\nModal Params', lines:['Select freq. bands','Curve-fit modes','Extract ωᵣ, ζᵣ, φᵣ','Stabilisation diag.']},
    {n:'4', color:'#e07b00', bg:'#fff5e6', title:'Validate\nMode Shapes',  lines:['Compute MAC matrix','Animate modes','Check orthogonality','Synthesise FRF']},
    {n:'5', color:'#9b59b6', bg:'#f5d0ff', title:'Update\nFEA Model',      lines:['Compare to FEA','Sensitivity analysis','Adjust parameters','Iterate until match']},
    {n:'6', color:'#555',    bg:'#f5f5f5', title:'Predict\nResponse',      lines:['Force response','Structural mods.','Fatigue life','Design changes']},
  ];

  const sw=130, sh=220, gap=18;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Complete Modal Analysis Workflow</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>
        {steps.map(({n,color,bg,title,lines},i) => {
          const x=10+i*(sw+gap);
          return (
            <g key={i}>
              <rect x={x} y={10} width={sw} height={sh} rx={6} fill={bg} stroke={color} strokeWidth="1.8"/>
              <rect x={x} y={10} width={sw} height={36} rx={6} fill={color}/>
              <rect x={x} y={30} width={sw} height={16} fill={color}/>
              <circle cx={x+18} cy={22} r={10} fill="rgba(255,255,255,0.25)"/>
              <text x={x+18} y={27} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{n}</text>
              {title.split('\n').map((l,j) => (
                <text key={j} x={x+sw/2} y={22+j*15} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{l}</text>
              ))}
              {lines.map((l,j) => (
                <g key={j}>
                  <circle cx={x+14} cy={56+j*36} r={3} fill={color}/>
                  <text x={x+22} y={60+j*36} fontSize="10" fill="#333">{l}</text>
                </g>
              ))}
              {/* Arrow to next step */}
              {i<steps.length-1 && (
                <line x1={x+sw+2} y1={120} x2={x+sw+gap-2} y2={120} stroke={color} strokeWidth="2" markerEnd="url(#mGy)"/>
              )}
            </g>
          );
        })}

        {/* Feedback loop arrow */}
        <path d={`M ${10+5*(sw+gap)+sw/2},${sh+10} Q ${10+5*(sw+gap)+sw/2},${H-10} ${10+4*(sw+gap)+sw/2},${H-10} Q ${10+3*(sw+gap)/2},${H-10} ${10+sw/2},${H-10} Q ${10},${H-10} ${10},${120}`}
          fill="none" stroke="#aaa" strokeWidth="1.5" strokeDasharray="6,4" markerEnd="url(#mGy)"/>
        <text x={W/2} y={H-2} textAnchor="middle" fontSize="10" fill="#aaa" fontStyle="italic">iterate if model does not meet targets</text>
      </svg>
      <div style={S.dCaption}>
        The complete modal analysis workflow is iterative. Starting from a test plan, FRF data is acquired and processed to extract modal parameters (ωᵣ, ζᵣ, φᵣ). The experimental mode shapes are validated against the FEA model using MAC and frequency comparison. If discrepancies exist, the model is updated by adjusting parameters until convergence. The validated model is then used for confident predictions of forced response, structural modifications, and design optimisation.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Main
// ─────────────────────────────────────────────────────────────────
export default function ModalAnalysis() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Modal Analysis in System Dynamics</h1>
      <p style={S.p}>
        Modal analysis is the process of characterising a dynamic system by its natural frequencies, damping ratios, and mode shapes — collectively called the modal parameters. It is the bridge between theory and experiment in structural dynamics: analytical modal analysis extracts these parameters from a mathematical model; experimental modal analysis (EMA) extracts them from measured vibration data. Together they form the standard workflow for validating computer models, diagnosing vibration problems, and predicting structural behaviour under any form of loading.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Modal parameters: natural frequencies ωᵣ, damping ratios ζᵣ, mode shapes {φᵣ} — fully describe linear dynamics",
        "FRF H(ω) = X(ω)/F(ω): measured transfer function, complex (amplitude + phase), one per input-output pair",
        "FRF is a sum of modal contributions: H(ω) = Σ Aᵣ/(ωₙᵣ²−ω²+2jζᵣωₙᵣω), Aᵣ = modal residue",
        "Peak-picking: ωₙ from amplitude peak, ζ from half-power bandwidth Δω/(2ωₙ)",
        "Phase method: ωₙ from exact 90° phase crossing — more reliable than amplitude peak",
        "Nyquist circle-fit: Im(H) vs Re(H) is a circle — ωₙ at top, diameter = 1/(cωₙ)",
        "MAC = (φ_Aᵀφ_X)²/[(φ_Aᵀφ_A)(φ_Xᵀφ_X)] — quantifies mode shape correlation (1=perfect)",
        "Model updating: adjust FEA parameters until ωᵣ and φᵣ match experimental values",
      ]}/>

      <h2 style={S.h2}>What Modal Analysis Is</h2>
      <DiagOverview/>

      <h2 style={S.h2}>The Frequency Response Function</h2>
      <p style={S.p}>
        The Frequency Response Function is the fundamental measured quantity in experimental modal analysis. H(ω) = X(ω)/F(ω) is the ratio of the Fourier transform of the response to the Fourier transform of the force at each frequency. It is complex — carrying both amplitude and phase information. Three equivalent forms are used depending on the sensor type: receptance (displacement/force), mobility (velocity/force), and accelerance (acceleration/force). All contain identical modal information, related by factors of jω.
      </p>
      <DiagFRFExplained/>
      <Table2 rows={[
        ["Receptance H_d(ω)","H_d = X/F   [m/N]\nThe most direct form; used in analytical derivations\nPeak location slightly below ωₙ for damped systems"],
        ["Mobility H_v(ω)","H_v = V/F = jω·H_d   [m/s/N]\nPeak location nearest ωₙ (closer than receptance)\nUsed in acoustic-structural coupling analysis"],
        ["Accelerance H_a(ω)","H_a = A/F = −ω²·H_d   [m/s²/N]\nMost common in practice — accelerometers are standard\nPeak at ωₙ for high frequencies (mass-dominated)"],
        ["FRF matrix H(ω)","H_ij(ω) = response at DOF i / force at DOF j\nn×n matrix for n-DOF system\nReciprocity: H_ij = H_ji — only n(n+1)/2 unique terms"],
        ["Coherence γ²(ω)","γ² = |S_xf|² / (S_xx · S_ff)  range 0 to 1\nγ² = 1: perfect linear relationship (ideal)\nγ² < 0.9: noise, nonlinearity, or leakage present"],
      ]}/>

      <h2 style={S.h2}>FRF of a Multi-DOF System</h2>
      <p style={S.p}>
        For a multi-DOF system, the FRF at any input-output pair is the sum of contributions from all modes. Each mode produces a resonance peak at its natural frequency; the measured FRF is the complex sum. This modal superposition structure is why all peaks in a measured FRF correspond to natural frequencies, and why the phase always passes through 90° at each one regardless of damping.
      </p>
      <DiagMDOFFRF/>
      <Table2 rows={[
        ["Modal superposition","H_ij(ω) = Σᵣ Aᵣᵢⱼ/(ωₙᵣ²−ω²+2jζᵣωₙᵣω)\nAᵣᵢⱼ = φᵣᵢ·φᵣⱼ/mᵣ*  (modal residue)\nSum over all n modes"],
        ["Modal residue A","Aᵣ = φᵣ_i × φᵣ_j / mᵣ*\nEncodes mode shape amplitude at both input and output DOFs\nExtracted from FRF during curve-fitting"],
        ["Contribution of each mode","Near ωₙᵣ: mode r dominates, others contribute smoothly\nFar from resonance: mode contributes real offset (residual)\nResidual stiffness and inertia: constant real corrections"],
        ["Anti-resonance","Minimum in |H(ω)| between two peaks\nOccurs where adjacent mode contributions cancel\nLocation depends on measurement point — not a system property"],
        ["Residuals","Out-of-band modes contribute static offset to FRF\nLower residual (LR): stiffness correction from modes below band\nUpper residual (UR): mass correction from modes above band\nImportant for accurate curve-fitting"],
      ]}/>

      <h2 style={S.h2}>Modal Parameter Extraction — SDOF Methods</h2>
      <p style={S.p}>
        Once FRF data is acquired, modal parameters are extracted by fitting mathematical models to the measured curves. SDOF methods process one mode at a time, treating each resonance region as if it were a single-DOF system. Three SDOF methods are standard: peak-picking (amplitude), half-power bandwidth (damping), and the Nyquist circle-fit (most accurate single-mode method).
      </p>
      <DiagSDOFExtraction/>
      <Table2 rows={[
        ["Peak-picking","ωₙ ≈ ω at peak of |H(ω)|\nSimple and fast — requires dense frequency resolution\nError: peak shifts to r*=√(1−2ζ²) below ωₙ; for ζ=0.1 error is 0.5%"],
        ["Half-power bandwidth","ζ = (ω₂−ω₁)/(2ωₙ)  where |H(ω₁,₂)| = |H_max|/√2\nAlso: ζ ≈ 1/(2Q) where Q = H_max/H_static\nRequires good frequency resolution near peak"],
        ["Phase slope method","d(φ)/dω at ω=ωₙ = −1/ζωₙ  →  ζ = −1/(ωₙ·dφ/dω)\nωₙ from 90° crossing (exact, independent of ζ)\nMore reliable than peak when FRF is noisy"],
        ["Nyquist circle-fit","SDOF H(ω) = A/[(ωₙ²−ω²)+j2ζωₙω]\nLocus in Im(H) vs Re(H) plane is a circle\nωₙ at maximum imaginary part; diameter d = 1/(2ζωₙ²mᵣ*)\nFit circle to measured points for most accurate extraction"],
        ["Inverse FRF method","1/H(ω) = Re + j·Im\n1/H passes through zero at ωₙ for undamped system\nUseful for identifying closely-spaced modes"],
      ]}/>

      <h2 style={S.h2}>Experimental Setup and Instrumentation</h2>
      <DiagExperimentalSetup/>
      <Table2 rows={[
        ["Impact hammer testing","Steel tip: high-frequency content (up to ~5 kHz)\nSoft rubber tip: low-frequency only (< 500 Hz)\nForce window: set to 1 after impulse to remove noise tail\nDouble-impact: ruins measurement — discard and repeat"],
        ["Shaker testing","Random, burst-random, swept-sine, stepped-sine excitation\nStinger rod (flexible rod between shaker and structure): avoids mass/stiffness loading\nBurst random: best leakage control with no windows needed"],
        ["Accelerometers","Piezoelectric: most common, wide frequency range\nMass loading error: accelerometer mass < 1% local mass\nMounting: stud mount (best), adhesive wax (temporary), hand-held (poor HF)"],
        ["Signal processing","Sampling: Nyquist — f_sample ≥ 2·f_max\nAnti-aliasing filter before ADC (mandatory)\nWindowing: Hann window for random; force/exponential for impact\nAveraging: n_avg spectra reduces random noise by √n_avg"],
        ["Boundary conditions","Free-free: suspend on soft bungees (lowest mode well below 1 Hz)\nFixed: bolt rigidly; any flexibility contaminates rigid-body mode\nMust match analytical boundary conditions used in FEA"],
      ]}/>

      <h2 style={S.h2}>Mode Shape Visualisation</h2>
      <DiagModeShapeVisualization/>
      <Table2 rows={[
        ["Measuring mode shapes","Measure column j of H: H_1j, H_2j, …, H_nj at fixed input j\nAt resonance ωᵣ: |H_ij(ωᵣ)| ∝ |φᵢᵣ|\nPhase determines sign: 0° = positive, 180° = negative"],
        ["Roving hammer / acc.","Roving hammer: move force point, fix single response\nRoving accelerometer: move sensor, fix single force point\nReciprocity ensures same result — hammer often faster"],
        ["Mode shape animation","Scale measured amplitudes to mode shape vector\nAnimate by multiplying by cos(ωᵣt)\nSoftware (ME'scope, ICATS): colour-coded, deformed mesh\nHelps identify nodal lines, bending/torsion character"],
        ["MAC criterion","MAC_rs = |{φᵣ}ᵀ{φₛ}|² / [{φᵣ}ᵀ{φᵣ} · {φₛ}ᵀ{φₛ}]  range 0 to 1\nMAC=1: modes identical;  MAC=0: orthogonal (uncorrelated)\nDiagonal should be ≥ 0.9;  off-diagonal should be ≤ 0.1"],
        ["Driving point FRF","H_ii: response and excitation at same DOF\nAlways positive real part at resonance\nImaginary part peaks alternate sign\nUsed to check quality of measurements — must follow sign rule"],
      ]}/>

      <h2 style={S.h2}>Multi-Mode Identification Methods</h2>
      <DiagMDOFIdentification/>
      <Table2 rows={[
        ["Rational fraction polynomial","H(ω) = N(ω)/D(ω) where N, D are polynomials in ω\nGlobal: simultaneous fit of all modes over full frequency band\nHandles overlapping modes; sensitive to frequency range selection"],
        ["Polyreference method","Multiple reference (input) points used simultaneously\nEnhances mode detection from a richer data set\nStabilisation diagram: plot poles vs increasing model order\nPhysical modes appear stable (constant ω, ζ); spurious modes scatter"],
        ["Stochastic Subspace (SSI)","State-space model identified from output-only data\nNo applied excitation: uses ambient vibration (wind, traffic, operation)\nCovariance-driven or data-driven variants\nEssential for large civil structures in service"],
        ["Stabilisation diagram","Fit model of increasing order n=1,2,3,…,N\nPlot poles at each order; stable pole = physical mode\nStability criteria: Δω<1%, Δζ<5%, ΔMAC<0.02 between orders\nSelect mode from stable column"],
        ["FRF synthesis check","Once modes extracted, synthesise FRF: H_synth = Σ Aᵣ/(...)\nCompare to measured H — good fit validates extraction\nResiduals needed for accurate synthesis outside identified band"],
      ]}/>

      <h2 style={S.h2}>Model Validation and Updating</h2>
      <p style={S.p}>
        The final step in modal analysis is comparing the experimental modal parameters to those predicted by the finite element model. Discrepancies reveal modelling errors in boundary conditions, material properties, joint stiffnesses, or mass distribution. Model updating adjusts the FEA parameters systematically until agreement is achieved — producing a validated model that can confidently predict response under operating conditions not tested experimentally.
      </p>
      <DiagModelUpdating/>
      <Table2 rows={[
        ["MAC matrix","n×n matrix comparing each analytical mode to each experimental mode\nDiagonal MAC ≥ 0.9: good mode shape correlation\nOff-diagonal MAC > 0.1: possible mode switching or contamination"],
        ["Frequency error","Δωᵣ/ωᵣ_exp: fractional frequency error for mode r\nTarget: < 5% before updating, < 1% after updating\nSystematic bias (all modes too stiff/soft) suggests global parameter error"],
        ["Sensitivity-based updating","Δλ = [∂λ/∂p]·Δp  where λ = eigenvalue, p = parameters\nSensitivity matrix S = ∂λ/∂p  (computed from FEA)\nΔp = −S⁺·Δλ  (pseudo-inverse update)"],
        ["Updating parameters","Young's modulus E, density ρ, thickness t (plate elements)\nJoint stiffness (bolted connections often too stiff in FEA)\nBoundary condition flexibility (often under-estimated)"],
        ["Validation criteria","MAC > 0.9 on diagonal, < 0.1 off-diagonal\nFrequency error < 3% for all target modes\nFRF synthesis error < 20% over frequency range\nCross-validation: check modes not used in updating"],
      ]}/>

      <h2 style={S.h2}>Complete Workflow</h2>
      <DiagWorkflow/>

      <InfoBox title="Key Formulae Summary" items={[
        "FRF:  H(ω) = X(ω)/F(ω) = Σᵣ Aᵣ/(ωₙᵣ²−ω²+2jζᵣωₙᵣω)",
        "Receptance/Mobility/Accelerance:  H_v = jω·H_d,  H_a = −ω²·H_d",
        "Peak-picking:  ωₙ ≈ ω_peak,  ζ = (ω₂−ω₁)/(2ωₙ)  [half-power BW]",
        "Phase at resonance:  φ = 90° exactly at r=1 for all ζ",
        "Nyquist circle diameter:  d = 1/(cωₙ) = 1/(2ζωₙ²mᵣ*)",
        "Modal residue:  Aᵣᵢⱼ = φᵣᵢ · φᵣⱼ / mᵣ*",
        "MAC:  MAC_rs = |{φᵣ}ᵀ{φₛ}|² / ({φᵣ}ᵀ{φᵣ} · {φₛ}ᵀ{φₛ})  — target ≥ 0.9 on diagonal",
        "Coherence:  γ²(ω) = |S_xf(ω)|² / [S_xx(ω)·S_ff(ω)]  — target ≥ 0.9",
      ]}/>
    </div>
  );
}